<template>
  <hc-base-index
    ref="hcBaseIndexRef"
    :pageTitle="pageTitle"
    :flowCode="flowCode"
    @openCreateDialog="openCreateDialog"
    @viewDetail="viewDetail"
    @openReportDialog="openReportDialog"
  >
    <template #extend="{hcFlowId}">
      <hc-scn-create-dialog
        :isOpen="isOpenDialogCreate"
        v-if="isEnableDialogCreate"
        @dialogClosed="isEnableDialogCreate = false"
        @closeDialog="isOpenDialogCreate = false"
        @insertSuccess="createSuccess"
      />
    </template>
  </hc-base-index>
</template>

<script type="text/javascript">
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import dateFormatter from "../../../filters/dateFormatter";
  import goBackMixin from "../../../mixins/goBackMixin";
  import utils from "../../../services/utils";
  import HcScnCreateDialog from "./hc-scn-create-dialog";
  import constants from "../../../constants";
  import HcBaseIndex from "../khachsan/hc-base-index";

  export default {
    mixins: [goBackMixin],

    components: {
      HcBaseIndex,
      HcScnCreateDialog,
      VuePerfectScrollbar
    },

    filters: {dateFormatter},

    data() {
      return {
        flowCode: constants.HC_FLOW.FLOW_CODE.SUA_CHUA_NHO,
        pageTitle: "Sữa chữa nhỏ",
        isOpenDialogCreate: false,
        isEnableDialogCreate: false,
        isOpenDialogReport: false,
        isEnableDialogReport: false
      };
    },

    watch: {
      isOpenDialogCreate(newValue) {
        if (newValue) this.isEnableDialogCreate = newValue;
      },
      isOpenDialogReport(newValue) {
        if (newValue) this.isEnableDialogReport = newValue;
      }
    },

    computed: {},

    created() {
    },

    methods: {
      openReportDialog() {
        this.isOpenDialogReport = true;
      },

      openCreateDialog() {
        this.isOpenDialogCreate = true;
      },

      createSuccess() {
        this.isOpenDialogCreate = false;
        this.doSearch();
      },

      doSearch() {
        this.$refs.hcBaseIndexRef.doSearch();
      },

      viewDetail(e) {
        let caseMasterId = e.caseMasterId;
        let params = utils.merge(this.$route.params, {id: caseMasterId});
        this.$router.push({
          name: "adminstration-suaChuaNho-detail",
          params: params,
          query: this.$route.query
        });
      }
    }
  };
</script>

<style type="text/css" scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/suachuanho/hc-scn-index.vue